import { Component, OnInit, ViewChild } from '@angular/core';
import { UtilService } from 'src/app/shared';
import { EventListHtDto } from '../shared/event-list-ht.dto';
import { SubmissionReviewModalComponent } from './submission-review-modal/submission-review-modal.component';

@Component({
  selector: 'wl-submissions',
  templateUrl: './submissions.component.html',
  styleUrls: ['./submissions.component.less'],
    standalone: false
})
export class SubmissionsComponent implements OnInit {
  @ViewChild('reviewModal') private _reviewModal: SubmissionReviewModalComponent;
  eventSubmission: EventListHtDto;
  constructor() {}

  ngOnInit(): void {}

  reviewSubmission(reviewSubmission: EventListHtDto) {
    this.eventSubmission = reviewSubmission;
    this._reviewModal.open(this.eventSubmission);
  }
}
